type CircuitState = "closed" | "open" | "half-open";

const FAILURE_THRESHOLD = 3;
const COOLDOWN_MS = 30_000;

let state: CircuitState = "closed";
let consecutiveFailures = 0;
let openedAt = 0;

export function recordSuccess() {
	consecutiveFailures = 0;
	state = "closed";
}

export function recordFailure() {
	consecutiveFailures++;
	if (consecutiveFailures >= FAILURE_THRESHOLD) {
		state = "open";
		openedAt = Date.now();
	}
}

export function canRequest(): boolean {
	if (state === "closed") return true;

	if (state === "open" && Date.now() - openedAt >= COOLDOWN_MS) {
		state = "half-open";
		return true;
	}

	return state === "half-open";
}

export function isServerError(status?: number): boolean {
	return !status || status >= 500;
}
